import {DocumentIssue} from "common/types/issue";

export default function isLlmIssueWithNullMeta(issue: DocumentIssue) {
  return issue.trigger_type === "LLM" && issue.llm_meta === null;
}
